<template>
  <v-content>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="titulos">Reserva de {{ this.$route.params.name }}</h1>
        </v-flex>
        <v-flex xs12 md5 offset-md1>
          <v-date-picker color="grey darken-3" header-color="grey darken-3" v-model="modal" firstDayOfWeek="1"
                         locale="es" class="margin" @change="cargarReservas"></v-date-picker>
        </v-flex>
        <v-flex xs12 md6 class="margin">
          <v-flex xs12 left>
            <v-btn dark color="teal" round outline v-on:click="mostrarHoras" v-if="seen">
              Reservar
            </v-btn>
          </v-flex>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            :pagination.sync="pagination"
            v-if="seen"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.Hour.start_time }}</td>
              <td>{{ props.item.Hour.end_time }}</td>
              <td>{{ props.item.User.fullName }}</td>
            </template>
            <template slot="no-data">
              <v-alert :value="true" color="info" icon="info">
                No hay reservas realizadas
              </v-alert>
            </template>
          </v-data-table>
          <v-flex xs12 v-if="seen == false">
            <v-data-table
              :headers="headersHour"
              :items="itemsHours"
              hide-actions
              :pagination.sync="pagination"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    v-model="props.item.selected"
                    :value="false"
                  ></v-checkbox>
                </td>
                <td>{{ props.item.Hour.start_time }}</td>
                <td>{{ props.item.Hour.end_time }}</td>
              </template>
              <template slot="no-data">
                <v-alert :value="true" color="error" icon="warning">
                  No hay horas disponibles
                </v-alert>
              </template>
            </v-data-table>
            <v-btn dark color="teal" round outline @click="realizarReserva">
              Aceptar
            </v-btn>
            <v-btn dark color="teal" round outline v-on:click="seen = !seen">
              Cancelar
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
      <v-snackbar
        :timeout=6000
        :color="color"
        :multi-line="'multi-line'"
        v-model="snackbar">
        <v-icon dark>error_outline</v-icon>
        {{ error }}
        <v-btn dark flat @click.native="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable */
  import Shared from '@/services/Shared';
  import store from '@/store/store'

  export default {
    data() {
      return {
        items: [],
        itemsHours: [],
        selected: [],
        headers: [
          {text: 'Hora de inicio', value: 'start_hour'},
          {text: 'Hora de fin', value: 'end_hour'},
          {text: 'Usuario', value: 'user'}
        ],
        headersHour: [
          {text: '', value: ''},
          {text: 'Hora de inicio', value: 'start_hour'},
          {text: 'Hora de fin', value: 'end_hour'},
        ],
        pagination: {
          rowsPerPage: 10
        },
        error: null,
        snackbar: false,
        color: '',
        modal: '',
        date: '',
        seen: true
      }
    },
    created() {
      this.resourceReservation(this.today())
    },
    methods: {
      today(){
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth()+1; //January is 0!
        let yyyy = today.getFullYear();
        return yyyy + '-' + mm + '-' + dd
      },
      async realizarReserva(){
        try{
          let elements = [];
          let items = {};
          this.itemsHours.forEach(function(element){
            if(element.selected){
              elements.push(element)
            }
          });
          if(elements.length > 0){
            items = {
              horas: elements,
              user_id: store.state.user.id,
              date: this.modal
            };
            const response = await Shared.createReservation(items);
            this.resourceReservation(this.modal);
            this.error = response.data.msg;
            this.snackbar = true;
            this.color = 'success';
            this.seen = true;
          }
        }catch(err){
          this.error = err.response.data.msg;
          this.snackbar = true;
          this.color = 'error';
        }
      },
      async mostrarHoras(){
        try{
          if(this.modal){
            this.seen = !this.seen;
            const response = await Shared.getHoursResource(this.$route.params.id, this.modal);
            this.itemsHours = response.data.data;
          }else{
            this.error = "Antes debe seleccionar una fecha";
            this.snackbar = true;
            this.color = 'error';
          }
        }catch(err){
          console.log(err);
        }
      },
      async resourceReservation(date) {
        try {
          const response = await Shared.reservationSearch(date, this.$route.params.id);
          this.items = response.data.data;
        } catch (err) {
          console.log(err);
        }
      },
      navigateTo(route) {
        this.$router.push(route);
      },
      reservar(id, name) {
        this.$router.push({name: "reservation", params: {id, name}});
      },
      async cargarReservas(value){
        //Buscar con esta fecha todas las reservas
        try{
          const response = await Shared.reservationSearch(value, this.$route.params.id);
          this.items = response.data.data;
          this.seen = true;
        } catch(err){
          console.log(err);
        }
      }
    },
    computed: {
      pages() {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) return 0;

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      }
    },
  };
</script>


<style scoped>
  .margin {
    margin-top: 50px;
  }
</style>




// WEBPACK FOOTER //
// src/components/reservation/Reservation.vue